"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CausalityUserDefinedFields = void 0;
var React = require("react");
var userDefinedField_1 = require("../userDefinedField");
var mobx_react_1 = require("mobx-react");
var CausalityUserDefinedFields = (function (_super) {
    __extends(CausalityUserDefinedFields, _super);
    function CausalityUserDefinedFields() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CausalityUserDefinedFields.prototype.get_values_of_type = function (udf_type) {
        if (this.props.udfValues == null)
            return [];
        return this.props.udfValues.filter(function (iFieldValue) {
            return iFieldValue.field_type.id == udf_type.id;
        });
    };
    CausalityUserDefinedFields.prototype.updateCustomField = function (udfType, udfValues) {
        var custom_values = this.props.udfValues;
        if (custom_values) {
            custom_values = custom_values.filter(function (custom_value) {
                return custom_value.field_type.id != udfType.id;
            });
        }
        else
            custom_values = [];
        custom_values = custom_values.concat(udfValues);
        this.props.onChange("udf_values", custom_values);
    };
    CausalityUserDefinedFields.prototype.render = function () {
        var fieldTypes = this.props.udfTypes;
        var field_rows = [];
        for (var i = 0; i < fieldTypes.length; i++) {
            field_rows.push(React.createElement(userDefinedField_1.UserDefinedField, { udf_type: fieldTypes[i], udf_values: this.get_values_of_type(fieldTypes[i]), target_object_id: this.props.target_object_id, onChange: this.updateCustomField.bind(this), render: userDefinedField_1.UDFRenderKind.STACKED }));
        }
        field_rows.push(React.createElement("div", { className: "row" },
            React.createElement("div", { className: "col-6" }),
            React.createElement("div", { className: "col-6 text-right" }, this.props.children)));
        return (React.createElement("div", { className: "CausalityInformationForm__UserDefined" }, field_rows));
    };
    CausalityUserDefinedFields = __decorate([
        mobx_react_1.observer
    ], CausalityUserDefinedFields);
    return CausalityUserDefinedFields;
}(React.Component));
exports.CausalityUserDefinedFields = CausalityUserDefinedFields;
